module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ci-c7146bc39c724cd34b46e01e2487c78a.svg";